'use client';

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
interface AstroNumbersProps {
  number: string; // Main large number inside the circle
  title: string; // "Number 1"
  subtitle: string; // Tamil line
  circleBg: string; // Circle background color
  circleTextColor: string; // Number color inside circle
}
export default function AstroNumbers(t0) {
  const $ = _c(22);
  const {
    number,
    title,
    subtitle,
    circleBg,
    circleTextColor
  } = t0;
  let t1;
  if ($[0] !== number) {
    t1 = typeof number === "string" && /\.(png|jpe?g|gif|svg|webp)$/i.test(number.trim());
    $[0] = number;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isImage = t1;
  let t2;
  if ($[2] !== circleBg || $[3] !== circleTextColor) {
    t2 = {
      width: "48px",
      height: "48px",
      backgroundColor: circleBg,
      color: circleTextColor,
      fontWeight: "700",
      fontSize: "20px"
    };
    $[2] = circleBg;
    $[3] = circleTextColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isImage || $[6] !== number || $[7] !== title) {
    t3 = isImage ? <Image src={number} alt={title} width={48} height={48} className="w-full h-full object-contain" /> : number;
    $[5] = isImage;
    $[6] = number;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="flex items-center justify-center rounded-full overflow-hidden" style={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== title) {
    t5 = <p className="text-16-tamil-700 text-012061 leading-none">{title}</p>;
    $[12] = title;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== subtitle) {
    t6 = <p className="text-[#000] text-[12px] mt-1 leading-tight">{subtitle}</p>;
    $[14] = subtitle;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="flex flex-col">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <div className="flex items-center gap-4 rounded p-4 w-full h-[81px] bg-FFFFFF border border-[#E0E0E0] transition-all ">{t4}{t7}</div>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}